<template>

  <div class="pad">
    <transition-group name="list" mode="out-in">
      <div class="list-group" v-for="ticket in tickets" :key="ticket.id">
        <div class="container ">
          <b-card class="hover">
            <div>
              <b-badge class="mb-2">{{dateFormat(ticket.createdAt.seconds)}} </b-badge>
            </div>
            <!-- User -->
            <h3>{{ticket.name}} </h3>
            <p class="card-text">
              {{ticket.description}}
              <div v-for="details in ticket.chat" :key="details.index">

                {{details.user}} - {{details.message}}

              </div>
            </p>
            <b-btn class="closeButton red-background" variant="danger" v-b-modal=ticket.id>
              <icon name="times" scale="1.8"></icon>
            </b-btn>
            <b-btn class="snTicketInit blue-background" v-b-modal="ticket.id + 1" variant="primary">
              <icon name="ticket" scale="1.8"></icon>
            </b-btn>
          </b-card>
        </div>
        <b-modal :id=ticket.id size="sm " ok-title="Close " @ok="$emit('closeTickets', ticket.id)" title="Close Ticket ">
          <p class="my-4 ">Are you sure you want to close ticket?</p>
        </b-modal>
        <b-modal :id="ticket.id + 1 " size="sm " ok-title="Create SN Incident " @ok="$emit('createServiceNow', {id: ticket.id, description: ticket.description, name: ticket.name, password: password}) " title="Create Incident ">
          <p class="my-4 ">Are you sure you want to create a Service-Now Incident?</p>
          <label for="pass">
            <h3>Enter Password</h3>
          </label>
          <b-input v-model="password" id="pass"></b-input>
        </b-modal>
      </div>
    </transition-group>
  </div>

</template>
<script>
export default {
  name: "Ticket_List",
  components: {},
  props: { tickets: {} },
  data() {
    return { password: "" };
  },

  methods: {
    dateFormat: function(seconds) {
      let date = new Date(0);
      date.setUTCSeconds(seconds);
      return date.toDateString();
    }
  }
};
</script>

<style scoped>
.closeButton {
  position: absolute;
  right: 0;
  top: 0;
  height: 50%;
  width: 15%;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  transition: 1s;
}

.snTicketInit {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 50%;
  width: 15%;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  transition: 1s;
}

.pad {
  width: inherit;
}

.hover:hover {
  z-index: 1;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  transition: all 200ms ease-in;
  transform: scale(1.06);
}
.hover {
  margin: 5px;
  z-index: 1;
  transition: all 200ms ease-in;
  transform: scale(1);
  min-height: 150px;
}
.shadow {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
}

.list-leave-to {
  transform: translateX(-90%);
  opacity: 0;
  transition: 1s;
}
.list-enter {
  transform: translateX(-100%);
  opacity: 0;
}

.list-enter-to {
  transition: all 1s;
  opacity: 1;
}
.list-change {
  transition: all 1s;
}

@media screen and (max-width: 820px) {
  .snTicketInit {
    width: 30%;
    transition: 1s;
  }
  .closeButton {
    width: 30%;
    transition: 1s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TicketList/TicketList.vue